import React from "react";
import { Button, CardActions, CardText, FontIcon } from "react-md";
import { Field, reduxForm } from "redux-form";
import ReactMDTextField from "../../../common/components/ReactMDTextField";
import CenteredSection from "../../../common/components/CenteredSection";
import RegistrationCard from "../RegistrationCard";
import { normalizePhone } from "../../../common/normalize";

const capitalize = s => {
  return s && s[0].toUpperCase() + s.slice(1);
};

const ConfirmPhone = ({
  handleSubmit,
  onSubmit,
  invalid,
  submitting,
  currentRegistration
}) => (
  <CenteredSection size={6} offset={3}>
    <RegistrationCard
      title={`Welcome Back, ${capitalize(currentRegistration.firstName)} !`}
      subtitle="Before continuing, please confirm your phone number."
    >
      <CardText>
        <section className="md-grid">
          <Field
            id="phone"
            name="phone"
            label="Phone"
            component={ReactMDTextField}
            type="tel"
            helpText="Enter the phone number used to register previously."
            leftIcon={<FontIcon>phone</FontIcon>}
            className="md-cell md-cell--12"
            required
            normalize={(value) => (value ? value.replace(/\D/g, "") : value)}
            validate={[
              v =>
                normalizePhone(v) === normalizePhone(currentRegistration.phone)
                  ? undefined
                  : "Incorrect Phone Number"
            ]}
          />
        </section>
      </CardText>
      <CardActions>
        <Button
          raised
          label="Wrong Email"
          className="md-cell--left"
          secondary
          onClick={() => onSubmit({ cancel: true })}
        />
        <Button
          raised
          label="Continue"
          className="md-cell--right"
          primary
          disabled={submitting || invalid}
          onClick={handleSubmit}
        />
      </CardActions>
    </RegistrationCard>
  </CenteredSection>
);

ConfirmPhone.propTypes = {};
ConfirmPhone.defaultProps = {};

export default reduxForm({
  form: "confirm-phone"
})(ConfirmPhone);



// WEBPACK FOOTER //
// ./src/registration/components/ConfirmPhone/ConfirmPhonePage.jsx